function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { ANCHOR_ELEMENT_ROLE } from "./constants";
import { Motivators } from "../../../models";
import { MotivatorChart } from "../../../models/Chart";
import { attuned_theme } from "../../../styles/theme";
import { UndefinedOrNullChartInstanceException } from "../../../util/exceptions";
import { ScatterChart } from "echarts/charts";
import { GridComponent, MarkAreaComponent, MarkLineComponent } from "echarts/components";
import { isNil, merge } from "lodash";
var EMPHASIS_ICON_WIDTH = 18;
var EMPHASIS_ICON_HEIGHT = 18;
var _tooltipFormatter = /*#__PURE__*/ new WeakMap(), _localizeCategoryLabel = /*#__PURE__*/ new WeakMap(), _valueAxisLabels = /*#__PURE__*/ new WeakMap(), _valueAxisPercentages = /*#__PURE__*/ new WeakMap(), _minChartHeight = /*#__PURE__*/ new WeakMap(), _emphasisIcon = /*#__PURE__*/ new WeakMap(), _highlightedItem = /*#__PURE__*/ new WeakMap(), _comparisonData = /*#__PURE__*/ new WeakMap(), _highlightItemOrSeries = /*#__PURE__*/ new WeakSet(), _generateValueAxisPercentages = /*#__PURE__*/ new WeakSet(), _generateValueAxisLabels = /*#__PURE__*/ new WeakSet(), _emphasizeCategoryLabel = /*#__PURE__*/ new WeakSet();
/**
 * Represents a Motivators Comparison chart.
 */ export var MotivatorsComparisonChart = /*#__PURE__*/ function(MotivatorChart) {
    "use strict";
    _inherits(MotivatorsComparisonChart, MotivatorChart);
    function MotivatorsComparisonChart(param) {
        var _param_theme = param.theme, theme = _param_theme === void 0 ? attuned_theme : _param_theme, _param_data = param.data, data = _param_data === void 0 ? {
            first: [],
            second: []
        } : _param_data, _param_eventCallbacks = param.eventCallbacks, eventCallbacks = _param_eventCallbacks === void 0 ? [] : _param_eventCallbacks, _param_valueAxisLabels = param.valueAxisLabels, valueAxisLabels = _param_valueAxisLabels === void 0 ? [] : _param_valueAxisLabels, _param_valueAxisPercentages = param.valueAxisPercentages, valueAxisPercentages = _param_valueAxisPercentages === void 0 ? [] : _param_valueAxisPercentages, tooltipFormatter = param.tooltipFormatter, localizeCategoryLabel = param.localizeCategoryLabel, emphasisIcon = param.emphasisIcon;
        _class_call_check(this, MotivatorsComparisonChart);
        var _this;
        _this = _call_super(this, MotivatorsComparisonChart, [
            merge({}, theme, {
                categoryAxis: {
                    axisLabel: {
                        show: true
                    },
                    axisTick: {
                        show: false
                    }
                }
            }),
            false,
            [
                GridComponent,
                ScatterChart,
                MarkAreaComponent,
                MarkLineComponent
            ],
            eventCallbacks
        ]), _class_private_method_init(_this, _highlightItemOrSeries), _class_private_method_init(_this, _generateValueAxisPercentages), _class_private_method_init(_this, _generateValueAxisLabels), _class_private_method_init(_this, _emphasizeCategoryLabel), _class_private_field_init(_this, _tooltipFormatter, {
            writable: true,
            value: null
        }), _class_private_field_init(_this, _localizeCategoryLabel, {
            writable: true,
            value: null
        }), _class_private_field_init(_this, _valueAxisLabels, {
            writable: true,
            value: []
        }), _class_private_field_init(_this, _valueAxisPercentages, {
            writable: true,
            value: []
        }), _class_private_field_init(_this, _minChartHeight, {
            writable: true,
            value: 125
        }), _class_private_field_init(_this, _emphasisIcon, {
            writable: true,
            value: {
                icon: '',
                width: EMPHASIS_ICON_WIDTH,
                height: EMPHASIS_ICON_HEIGHT
            }
        }), _class_private_field_init(_this, _highlightedItem, {
            writable: true,
            value: {
                seriesIndex: null,
                dataIndex: null
            }
        }), _class_private_field_init(_this, _comparisonData, {
            writable: true,
            value: {
                first: [],
                second: [],
                motivators: []
            }
        });
        _this.comparisonData = data;
        _class_private_field_set(_this, _tooltipFormatter, tooltipFormatter);
        _class_private_field_set(_this, _localizeCategoryLabel, localizeCategoryLabel);
        _class_private_field_set(_this, _valueAxisLabels, _class_private_method_get(_this, _generateValueAxisLabels, generateValueAxisLabels).call(_this, valueAxisLabels));
        _class_private_field_set(_this, _valueAxisPercentages, _class_private_method_get(_this, _generateValueAxisPercentages, generateValueAxisPercentages).call(_this, valueAxisPercentages));
        if (emphasisIcon) {
            _class_private_field_set(_this, _emphasisIcon, emphasisIcon);
        }
        _this.options = {
            animation: true,
            tooltip: {
                alwaysShowContent: false,
                formatter: _class_private_field_get(_this, _tooltipFormatter) ? function(d) {
                    return _class_private_field_get(_this, _tooltipFormatter).call(_this, d);
                } : function(d) {
                    return d.data.motivator;
                }
            },
            grid: {
                show: false,
                containLabel: true,
                height: 'auto',
                top: 20,
                bottom: 40,
                left: 25,
                right: 50
            },
            xAxis: {
                type: 'value',
                show: false,
                min: 0,
                max: 100
            },
            yAxis: {
                triggerEvent: true,
                type: 'category',
                boundaryGap: false,
                data: _this.comparisonData.motivators,
                axisLabel: {
                    color: _this.theme._components.scatterPlot.categoryAxisLabel.color,
                    rich: {
                        emphArrowPlaceholder: {
                            width: _class_private_field_get(_this, _emphasisIcon).width
                        }
                    },
                    formatter: function(value) {
                        return "{emphArrowPlaceholder|}	".concat(_class_private_field_get(_this, _localizeCategoryLabel) ? _class_private_field_get(_this, _localizeCategoryLabel).call(_this, value) : value);
                    }
                },
                axisLine: {
                    show: false
                }
            },
            series: [
                {
                    name: 'data-first',
                    data: data.first,
                    type: 'scatter',
                    symbolSize: 15,
                    symbol: 'circle',
                    itemStyle: {
                        opacity: 1,
                        borderWidth: 16,
                        color: _this.theme._palette.colors.brand.motivators.gaps.first,
                        borderColor: _this.theme._palette.colors.shade.white.transparent,
                        shadowColor: _this.theme._palette.colors.shade.white.transparent,
                        shadowOffsetY: 0,
                        shadowOffsetX: 0,
                        shadowBlur: 10
                    },
                    // dot-label-anchor
                    label: {
                        show: true,
                        silent: true,
                        position: 'right',
                        color: _this.theme._palette.colors.brand.motivators.gaps.first,
                        // biome-ignore lint/suspicious/noExplicitAny: <explanation>
                        formatter: function(param) {
                            var data = param.data;
                            return "".concat(data.value, "%");
                        }
                    },
                    emphasis: {
                        disabled: false,
                        scale: 1.5,
                        itemStyle: {
                            shadowColor: _this.theme._palette.colors.brand.motivators.gaps.first
                        }
                    },
                    zlevel: 2,
                    // Y Axis horizontal line markers
                    markLine: {
                        silent: true,
                        symbol: 'none',
                        label: {
                            show: false
                        },
                        zlevel: 1,
                        lineStyle: {
                            color: _this.theme._components.scatterPlot.categoryAxisGuideLine.color
                        }
                    }
                },
                {
                    name: 'data-second',
                    type: 'scatter',
                    data: data.second,
                    symbolSize: 15,
                    itemStyle: {
                        opacity: 1,
                        borderWidth: 2,
                        color: _this.theme._palette.colors.brand.motivators.gaps.second,
                        borderColor: _this.theme._palette.colors.shade.white.transparent,
                        shadowColor: _this.theme._palette.colors.shade.white.transparent,
                        shadowOffsetY: 0,
                        shadowOffsetX: 0,
                        shadowBlur: 10
                    },
                    // dot-label-anchor
                    label: {
                        show: true,
                        silent: true,
                        position: 'right',
                        color: _this.theme._palette.colors.brand.motivators.gaps.second,
                        // biome-ignore lint/suspicious/noExplicitAny: <explanation>
                        formatter: function(param) {
                            var data = param.data;
                            return "".concat(data.value, "%");
                        }
                    },
                    emphasis: {
                        disabled: false,
                        scale: 1.5,
                        itemStyle: {
                            shadowColor: _this.theme._palette.colors.brand.motivators.gaps.second
                        }
                    },
                    zlevel: 2,
                    // X Axis vertical line markers
                    markLine: {
                        name: 'x-value-axis-vertical-line',
                        silent: true,
                        label: {
                            position: 'start',
                            distance: 20,
                            color: _this.theme._components.scatterPlot.valueAxisLabel.color,
                            formatter: function(param) {
                                var value = param.value;
                                return "".concat(value, "%");
                            }
                        },
                        symbol: 'none',
                        animation: false,
                        zlevel: 2,
                        lineStyle: {
                            color: _this.theme._components.scatterPlot.valueAxisPercentageLine.color
                        },
                        data: _to_consumable_array(_class_private_field_get(_this, _valueAxisPercentages))
                    },
                    // X Axis percentage labels
                    markArea: {
                        name: 'x-value-axis-percent-labels',
                        silent: true,
                        label: {
                            position: 'bottom',
                            distance: 20,
                            color: _this.theme._components.scatterPlot.valueAxisLabel.color
                        },
                        itemStyle: {
                            opacity: 0
                        },
                        data: _to_consumable_array(_class_private_field_get(_this, _valueAxisLabels))
                    }
                }
            ]
        };
        return _this;
    }
    _create_class(MotivatorsComparisonChart, [
        {
            key: "comparisonData",
            get: function get() {
                return _class_private_field_get(this, _comparisonData);
            },
            set: function set(data) {
                _class_private_field_set(this, _comparisonData, {
                    first: data.first,
                    second: data.second,
                    motivators: data.first.map(function(m) {
                        return m.motivator;
                    })
                });
            }
        },
        {
            key: "dimensions",
            get: /**
   * Returns the dimensions of the Chart.
   *
   * @returns An object containing the height and width of the object.
   *                   The height is calculated based on the length of the motivators array
   *                   in the comparisonData, multiplied by 50. The width is obtained by
   *                   calling the getWidth() method of the instance object.
   */ function get() {
                var calculatedHeight = this.comparisonData.motivators.length * 50;
                return {
                    height: calculatedHeight > _class_private_field_get(this, _minChartHeight) ? calculatedHeight : _class_private_field_get(this, _minChartHeight),
                    width: this.instance.getWidth()
                };
            }
        },
        {
            key: "highlightedItem",
            get: function get() {
                return _class_private_field_get(this, _highlightedItem);
            }
        },
        {
            key: "hasHighlightedItem",
            get: function get() {
                return !(isNil(_class_private_field_get(this, _highlightedItem).dataIndex) && isNil(_class_private_field_get(this, _highlightedItem).seriesIndex));
            }
        },
        {
            key: "applyData",
            value: function applyData(data) {
                if (!data || !data.first || !data.second) return;
                this.comparisonData = data;
                this._adjustContainerDimensions({
                    height: this.dimensions.height
                });
                this.applyOptions({
                    yAxis: {
                        data: this.comparisonData.motivators
                    },
                    series: [
                        {
                            name: 'data-first',
                            data: data.first,
                            markLine: {
                                data: this.comparisonData.first.map(function(m) {
                                    return {
                                        yAxis: m.motivator
                                    };
                                })
                            }
                        },
                        {
                            name: 'data-second',
                            data: data.second
                        }
                    ]
                });
            }
        },
        {
            key: "mountInstance",
            value: function mountInstance(el) {
                var _this = this;
                _get(_get_prototype_of(MotivatorsComparisonChart.prototype), "mountInstance", this).call(this, el, {
                    finished: function() {
                        _this._parseTextDataAttributes();
                    }
                });
            }
        },
        {
            key: "highlightFirstDataItem",
            value: function highlightFirstDataItem() {
                this.highlightDataItem(0, 0);
            }
        },
        {
            key: "highlightFirstDataSeries",
            value: function highlightFirstDataSeries(cb) {
                this.highlightDataSeries(0);
                if (!cb) return;
                var firstSeriesMotivator = Motivators[this.comparisonData.first[0].motivator];
                cb({
                    scaleId: firstSeriesMotivator.id,
                    scaleName: firstSeriesMotivator.name
                });
            }
        },
        {
            key: "highlightDataSeries",
            value: function highlightDataSeries(dataIndex) {
                if (!this.instance) throw new UndefinedOrNullChartInstanceException();
                if (isNil(dataIndex)) return;
                // Unhighlight current item, but may need to highlight other item if selecting another
                if (this.hasHighlightedItem) {
                    this.unhighlightDataItem();
                }
                _class_private_method_get(this, _highlightItemOrSeries, highlightItemOrSeries).call(this, {
                    dataIndex: dataIndex
                });
                _class_private_method_get(this, _emphasizeCategoryLabel, emphasizeCategoryLabel).call(this);
            }
        },
        {
            key: "highlightDataItem",
            value: function highlightDataItem(seriesIndex, dataIndex) {
                if (!this.instance) throw new UndefinedOrNullChartInstanceException();
                if (isNil(seriesIndex) || isNil(dataIndex)) return;
                // Unhighlight current item, but may need to highlight other item if selecting another
                if (this.hasHighlightedItem) {
                    this.unhighlightDataItem();
                }
                _class_private_method_get(this, _highlightItemOrSeries, highlightItemOrSeries).call(this, {
                    seriesIndex: seriesIndex,
                    dataIndex: dataIndex
                });
                _class_private_method_get(this, _emphasizeCategoryLabel, emphasizeCategoryLabel).call(this);
            }
        },
        {
            key: "unhighlightDataItem",
            value: function unhighlightDataItem() {
                if (!this.instance) throw new UndefinedOrNullChartInstanceException();
                if (!this.hasHighlightedItem) return;
                this.instance.dispatchAction({
                    type: 'downplay'
                });
                _class_private_field_set(this, _highlightedItem, {
                    seriesIndex: null,
                    dataIndex: null
                });
            }
        }
    ]);
    return MotivatorsComparisonChart;
}(MotivatorChart);
_define_property(MotivatorsComparisonChart, "anchors", ANCHOR_ELEMENT_ROLE);
_define_property(MotivatorsComparisonChart, "event", _object_spread_props(_object_spread({}, _get(_get_prototype_of(MotivatorsComparisonChart), "event", MotivatorsComparisonChart)), {
    onItemClick: function(param) {
        var callback = param.callback;
        return {
            event: 'click',
            cb: function(params) {
                if (!callback) return;
                if (params.componentType !== 'series' && params.componentSubType !== 'scatter') return;
                var data = params.data, seriesIndex = params.seriesIndex, dataIndex = params.dataIndex;
                callback({
                    data: data,
                    seriesIndex: seriesIndex,
                    dataIndex: dataIndex
                });
            }
        };
    },
    onCategoryClick: function(param) {
        var callback = param.callback;
        return {
            event: 'click',
            query: 'yAxis.category',
            cb: function(params) {
                if (!callback) return;
                if (params.componentType !== 'yAxis') return;
                var clickedMotivator = Motivators[params.value];
                callback({
                    data: {
                        scaleName: clickedMotivator.name,
                        scaleId: clickedMotivator.id
                    },
                    dataIndex: params.dataIndex
                });
            }
        };
    }
}));
function highlightItemOrSeries(opts) {
    this.instance.dispatchAction(_object_spread({
        type: 'highlight'
    }, opts));
    _class_private_field_set(this, _highlightedItem, {
        seriesIndex: opts.seriesIndex,
        dataIndex: opts.dataIndex
    });
}
function generateValueAxisPercentages(values) {
    var _this = this;
    return values.map(function(v) {
        return {
            xAxis: v.percent,
            lineStyle: v.shouldEmphasiseLine ? _object_spread_props(_object_spread({}, v.lineStyle), {
                type: 'solid',
                color: _this.theme._components.scatterPlot.bookend.color
            }) : v.lineStyle
        };
    });
}
function generateValueAxisLabels(labels) {
    return labels.map(function(l) {
        return [
            {
                xAxis: l.start,
                label: {
                    silent: true,
                    formatter: function() {
                        return l.label;
                    }
                },
                itemStyle: l.itemStyle
            },
            {
                xAxis: l.end
            }
        ];
    });
}
function emphasizeCategoryLabel() {
    var _this = this;
    if (!this.instance) throw new UndefinedOrNullChartInstanceException();
    this.instance.setOption({
        yAxis: {
            axisLabel: {
                rich: {
                    emphArrowImage: {
                        width: _class_private_field_get(this, _emphasisIcon).width,
                        height: _class_private_field_get(this, _emphasisIcon).height,
                        verticalAlign: 'middle',
                        align: 'center',
                        backgroundColor: {
                            image: _class_private_field_get(this, _emphasisIcon).icon
                        }
                    },
                    emph: {
                        fontSize: 14,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        color: this.theme._components.scatterPlot.categoryAxisLabel.color
                    }
                },
                formatter: function(value, index) {
                    if (_class_private_field_get(_this, _highlightedItem).dataIndex !== index) {
                        return "{emphArrowPlaceholder|}	".concat(_class_private_field_get(_this, _localizeCategoryLabel) ? _class_private_field_get(_this, _localizeCategoryLabel).call(_this, value) : value);
                    }
                    if (!_class_private_field_get(_this, _emphasisIcon).icon) {
                        return "{emphArrowPlaceholder|}	{emph|".concat(_class_private_field_get(_this, _localizeCategoryLabel).call(_this, value), "}");
                    }
                    return "{emphArrowImage|}	{emph|".concat(_class_private_field_get(_this, _localizeCategoryLabel).call(_this, value), "}");
                }
            }
        }
    });
}

//# sourceMappingURL=MotivatorsComparisonChart.js.map